import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IEvent } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class EventsApiClient extends BaseApiClient<IEvent, any, FilterQuery<IEvent>, IEvent, IEvent> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.events}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }
}